import type { DevtoolUIProps } from '@hookform/devtools/dist/devToolUI';
import dynamic from 'next/dynamic';

import env from '@/lib/env/client';

const DevTool = dynamic<DevtoolUIProps>(
  () => import('@hookform/devtools').then((mod) => mod.DevTool),
  {
    ssr: false,
  },
);

type HookFormDevtoolProps = {
  // biome-ignore lint/suspicious/noExplicitAny: Dev-only component — accept any form's control object
  control: any;
};

export default function HookFormDevtool({ control }: HookFormDevtoolProps) {
  if (!env.NEXT_PUBLIC_USE_HOOKFORM_DEVTOOLS) {
    return null;
  }

  return <DevTool control={control} />;
}
